import React, { useMemo, useCallback } from "react";
import PropTypes from "prop-types";
import countries from "i18n-iso-countries";
countries.registerLocale(require("i18n-iso-countries/langs/nl.json"));

function CountrySelect({ value, onChange, disabled, id }) {
    const options = useMemo(() => {
        const alpha3Codes = countries.getAlpha3Codes();
        
        return Object.keys(alpha3Codes).map(alpha3 => {
            const dutchName = countries.getName(alpha3, "nl", { select: "alias" }) || 
                             countries.getName(alpha3, "nl", { select: "official" });
            
            return {
                value: alpha3,
                label: dutchName
            };
        }).sort((a, b) => a.label.localeCompare(b.label));
    }, []);
    
    const handleChange = useCallback((event) => {
        onChange({
            target: {
                id: id,
                value: event.target.value
            }
        });
    }, [onChange, id]);
    
    return (
        <select 
            id={id}
            className="form-control"
            value={value || ""}
            onChange={handleChange}
            disabled={disabled}
        >
            <option value="">Selecteer een land</option>
            {options.map(country => (
                <option key={country.value} value={country.value}>
                    {country.label}
                </option>
            ))}
        </select>
    );
}

CountrySelect.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    id: PropTypes.string
};

CountrySelect.defaultProps = {
    value: "",
    disabled: false,
    id: "country"
};

export default CountrySelect;
